export enum Permission {
  /** View partner-managed bulk delivery routes for truck fleet operations */
  PartnerBulkDeliveryRouteView = 'partner_bulk_delivery_route.view',

  /** Manage (edit, cancel) partner-managed bulk delivery routes */
  PartnerBulkDeliveryRouteModify = 'partner_bulk_delivery_route.modify',
}
